import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus, FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AdminCoupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCoupons();
  }, [currentPage, searchQuery]);

  const fetchCoupons = async () => {
    try {
      const response = await axios.get(
        `/api/admin/coupons?page=${currentPage}&search=${searchQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCoupons(response.data.coupons);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching coupons:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this coupon?')) {
      try {
        await axios.delete(`/api/admin/coupons/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchCoupons();
      } catch (error) {
        console.error('Error deleting coupon:', error);
      }
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchCoupons();
  };

  return (
    <div className='container mx-auto px-4 py-8'>
      <h1 className='text-2xl font-bold mb-6'>Coupons</h1>
      <div className='mb-4 flex justify-between items-center'>
        <form onSubmit={handleSearch} className='flex items-center'>
          <input
            type='text'
            placeholder='Search coupons...'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className='p-2 border rounded mr-2'
          />
          <button
            type='submit'
            className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
          >
            <FaSearch />
          </button>
        </form>
        <button
          onClick={() => navigate('/admin/coupons/create')}
          className='bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 transition duration-200'
        >
          <FaPlus className='mr-2 inline' /> Create Coupon
        </button>
      </div>
      <table className='min-w-full bg-white rounded-lg shadow-md'>
        <thead>
          <tr>
            <th className='px-4 py-2 border-b'>Code</th>
            <th className='px-4 py-2 border-b'>Customer</th>
            <th className='px-4 py-2 border-b'>Restaurant</th>
            <th className='px-4 py-2 border-b'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {coupons.map((coupon) => (
            <tr key={coupon._id}>
              <td className='px-4 py-2 border-b'>{coupon.code}</td>
              <td className='px-4 py-2 border-b'>
                {coupon.customer.phoneNumber}
              </td>
              <td className='px-4 py-2 border-b'>{coupon.restaurant.name}</td>
              <td className='px-4 py-2 border-b flex'>
                <button
                  onClick={() => navigate(`/admin/coupons/edit/${coupon._id}`)}
                  className='bg-yellow-500 text-white py-2 px-4 rounded hover:bg-yellow-700 transition duration-200 mr-2'
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => handleDelete(coupon._id)}
                  className='bg-red-500 text-white py-2 px-4 rounded hover:bg-red-700 transition duration-200'
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='flex justify-between mt-4'>
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          className='bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-700 transition duration-200'
        >
          Previous
        </button>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
          className='bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-700 transition duration-200'
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdminCoupons;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
// import Pagination from '../Common/Pagination';

// const AdminCoupons = () => {
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [pages, setPages] = useState(1);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchCoupons = async () => {
//       try {
//         const response = await axios.get(
//           `/api/admin/coupons?pageNumber=${page}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setCoupons(response.data.coupons);
//         setPages(response.data.pages);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching coupons:', error);
//         setLoading(false);
//       }
//     };

//     fetchCoupons();
//   }, [page, token]);

//   const deleteCoupon = async (id) => {
//     if (window.confirm('Are you sure you want to delete this coupon?')) {
//       try {
//         await axios.delete(`/api/admin/coupons/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setCoupons(coupons.filter((coupon) => coupon._id !== id));
//       } catch (error) {
//         console.error('Error deleting coupon:', error);
//       }
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Manage Coupons</h1>
//       <Link
//         to='/admin/coupons/create'
//         className='inline-block bg-blue-500 text-white py-2 px-4 rounded mb-8'
//       >
//         <FaPlus className='mr-2 inline' /> Add Coupon
//       </Link>
//       <table className='w-full text-left'>
//         <thead>
//           <tr>
//             <th className='p-4 border-b'>Name</th>
//             <th className='p-4 border-b'>Discount</th>
//             <th className='p-4 border-b'>Validity</th>
//             <th className='p-4 border-b'>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {coupons &&
//             coupons.map((coupon) => (
//               <tr key={coupon._id}>
//                 <td className='p-4 border-b'>{coupon.name}</td>
//                 <td className='p-4 border-b'>{coupon.discount}%</td>
//                 <td className='p-4 border-b'>
//                   {new Date(coupon.validity).toLocaleDateString()}
//                 </td>
//                 <td className='p-4 border-b flex'>
//                   <Link
//                     to={`/admin/coupons/${coupon._id}/edit`}
//                     className='mr-4 text-blue-500'
//                   >
//                     <FaEdit />
//                   </Link>
//                   <button
//                     onClick={() => deleteCoupon(coupon._id)}
//                     className='text-red-500'
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </table>
//       <Pagination
//         page={page}
//         pages={pages}
//         onChangePage={(newPage) => setPage(newPage)}
//       />
//     </div>
//   );
// };

// export default AdminCoupons;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { FaRegEdit, FaTrashAlt, FaPlus } from 'react-icons/fa';

// const AdminCoupons = () => {
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchCoupons = async () => {
//       try {
//         const response = await axios.get('/api/admin/coupons', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setCoupons(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching coupons:', error);
//         setLoading(false);
//       }
//     };

//     fetchCoupons();
//   }, [token]);

//   const handleDelete = async (couponId) => {
//     try {
//       await axios.delete(`/api/admin/coupons/${couponId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setCoupons(coupons.filter((coupon) => coupon._id !== couponId));
//     } catch (error) {
//       console.error('Error deleting coupon:', error);
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-3xl font-bold mb-6'>Manage Coupons</h1>

//       <div className='mb-4'>
//         <button className='bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded flex items-center'>
//           <FaPlus className='mr-2' /> Add New Coupon
//         </button>
//       </div>

//       <ul>
//         {coupons.map((coupon) => (
//           <li
//             key={coupon._id}
//             className='mb-4 p-4 bg-gray-100 rounded shadow-sm flex justify-between items-center'
//           >
//             <div>
//               <h2 className='text-xl font-semibold'>{coupon.code}</h2>
//               <p>Discount: {coupon.discount}%</p>
//               <p>
//                 Expiry Date: {new Date(coupon.expiryDate).toLocaleDateString()}
//               </p>
//               <p>Restaurant: {coupon.restaurant.name}</p>
//             </div>
//             <div className='flex items-center'>
//               <button className='bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2 flex items-center'>
//                 <FaRegEdit className='mr-2' /> Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(coupon._id)}
//                 className='bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded flex items-center'
//               >
//                 <FaTrashAlt className='mr-2' /> Delete
//               </button>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default AdminCoupons;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaTrash, FaEdit, FaTicketAlt } from 'react-icons/fa';
// import ConfirmDialog from '../Common/ConfirmDialog';

// const AdminCoupons = () => {
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isDialogOpen, setIsDialogOpen] = useState(false);
//   const [selectedCouponId, setSelectedCouponId] = useState(null);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchCoupons = async () => {
//       try {
//         const response = await axios.get('/api/admin/coupons', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setCoupons(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchCoupons();
//   }, [token]);

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`/api/admin/coupons/${selectedCouponId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setCoupons(coupons.filter((coupon) => coupon._id !== selectedCouponId));
//       setIsDialogOpen(false);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div className="text-red-500">{error}</div>;

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-3xl font-bold mb-6">Coupons</h1>
//       <div className="mb-4">
//         <Link
//           to="/admin/coupons/create"
//           className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 transition duration-200 inline-flex items-center"
//         >
//           <FaTicketAlt className="mr-2" /> Create Coupon
//         </Link>
//       </div>
//       <div className="bg-white shadow-md rounded-lg overflow-hidden">
//         <table className="min-w-full bg-white">
//           <thead>
//             <tr>
//               <th className="py-2 px-4 border-b border-gray-200">Code</th>
//               <th className="py-2 px-4 border-b border-gray-200">Description</th>
//               <th className="py-2 px-4 border-b border-gray-200">Expiration Date</th>
//               <th className="py-2 px-4 border-b border-gray-200">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {coupons.map((coupon) => (
//               <tr key={coupon._id}>
//                 <td className="py-2 px-4 border-b border-gray-200">{coupon.code}</td>
//                 <td className="py-2 px-4 border-b border-gray-200">{coupon.description}</td>
//                 <td className="py-2 px-4 border-b border-gray-200">
//                   {new Date(coupon.expirationDate).toLocaleDateString()}
//                 </td>
//                 <td className="py-2 px-4 border-b border-gray-200">
//                   <Link
//                     to={`/admin/coupons/${coupon._id}/edit`}
//                     className="bg-blue-500 text-white py-1 px-3 rounded hover:bg-blue-700 transition duration-200 mr-2"
//                   >
//                     <FaEdit />
//                   </Link>
//                   <button
//                     onClick={() => {
//                       setSelectedCouponId(coupon._id);
//                       setIsDialogOpen(true);
//                     }}
//                     className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-700 transition duration-200"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmDialog
//         isOpen={isDialogOpen}
//         title="Delete Coupon"
//         message="Are you sure you want to delete this coupon? This action cannot be undone."
//         onConfirm={handleDelete}
//         onCancel={() => setIsDialogOpen(false)}
//       />
//     </div>
//   );
// };

// export default AdminCoupons;
